<template>
  <div class="lxm-contact-contact">
    <!--<lxm-nav :title="'王小华'"></lxm-nav>-->

    <div class="page">
      <div class="lxm-contact-contact__item box" id="contact-base">
        <article class="media">
          <figure class="media-left">
            <lxm-avatar :size="'3.2143rem'"
                        :src="state.avatar"
                        :name="state.name"
                        :isFemale="state.isFemale"></lxm-avatar>
          </figure>
          <div class="media-content">
            <div class="lxm-contact-contact__line" :style="marginPhoneBottom(state)">
              <img class="lxm-contact-contact__item-phone-icon"
                   src="../../../images/main/contact/phone.png" />
              <span>{{ state.phone }}</span>
            </div>
            <div v-if="state.phone2 && state.phone != state.phone2" class="lxm-contact-contact__line lxm-contact-contact__line_align" style="margin-bottom: 5px;">
              <span>{{ state.phone2 }}</span>
            </div>

            <div class="lxm-contact-contact__line" :style="marginMailBottom(state)">
              <img class="lxm-contact-contact__item-mail-icon"
                   src="../../../images/main/contact/mail.png" />
              <span>{{ state.mail }}</span>
            </div>
            <div v-if="state.mail2 && state.mail != state.mail2" class="lxm-contact-contact__line lxm-contact-contact__line_align">
              <span>{{ state.mail2 }}</span>
            </div>
          </div>
        </article>
      </div>

      <div class="lxm-contact-contact__tabs">
        <lxm-tabs :tabs="tabs"></lxm-tabs>
      </div>
      <transition name="lxm-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <!--<bottom-bar :phone="state.phone"
                :address="state.address"></bottom-bar>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/variables.styl'
  .lxm-contact-contact__item
    &.box
      padding: spacing-small spacing spacing
      &:not(:last-child)
        margin-bottom: spacing-big
    .media-left
      margin-right: siz(65)
  .lxm-contact-contact__line
    font-size: size
    line-height: 1
    color: grey-darker
    font-size: 0
    &:not(:last-child)
      margin-bottom: spacing
    img, span
        vertical-align: middle
    span
      padding-left: spacing-small
      font-size: size
      color: grey-dark
  phone-icon-padding = siz(2.5)
  .lxm-contact-contact__item-phone-icon
    width: siz(10.5) + phone-icon-padding
    height: siz(14)
    padding-right: phone-icon-padding
  .lxm-contact-contact__item-mail-icon
    width: siz(13)
    height: siz(11)

  .lxm-contact-contact__tabs
    margin-bottom: spacing

  .lxm-contact-contact__line_align
    margin-left: 13px
    margin-bottom: 5px;
</style>

<script>
  import LxmNav from '../../common/LxmNav.vue'
  import LxmAvatar from '../../common/LxmAvatar.vue'
  import LxmTabs from '../../common/LxmTabs.vue'
  import * as aTypes from '../../../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmAvatar,
      LxmTabs
    },
    mounted () {
      this.$store.dispatch(aTypes.CONTACT_GET_CONTACT, this.$route.query.contactId)
      this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达任意联系人详情页' })
    },
    computed: {
      tabs () {
        return [{
          name: '基本信息',
          to: {
            path: '/main/contact/contact/info',
            query: this.$route.query
          },
          active: this.$route.path === '/main/contact/contact/info' || this.$route.path === '/main/contact/contact'
        }, {
          name: '交互轨迹',
          to: {
            path: '/main/contact/contact/log',
            query: this.$route.query
          },
          active: this.$route.path === '/main/contact/contact/log'
        }]
      },
      state () {
        return this.$store.state.contact.contact
      }
    },
    methods: {
      marginPhoneBottom (state) {
        if (state.phone2 && state.phone !== state.phone2) {
          return 'margin-bottom: 5px;'
        } else {
          return 'margin-bottom: 16px;'
        }
      },
      marginMailBottom (state) {
        if (state.mail2 && state.mail !== state.mail2) {
          return 'margin-bottom: 5px;'
        } else {
          return 'margin-bottom: 16px;'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?47005174